import { render, staticRenderFns } from "./SVGSection.vue?vue&type=template&id=4d341ac8&scoped=true"
import script from "./SVGSection.vue?vue&type=script&lang=js"
export * from "./SVGSection.vue?vue&type=script&lang=js"
import style0 from "./SVGSection.vue?vue&type=style&index=0&id=4d341ac8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d341ac8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d341ac8')) {
      api.createRecord('4d341ac8', component.options)
    } else {
      api.reload('4d341ac8', component.options)
    }
    module.hot.accept("./SVGSection.vue?vue&type=template&id=4d341ac8&scoped=true", function () {
      api.rerender('4d341ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SVGSection.vue"
export default component.exports